import { TDocumentVisibilityStatus } from 'FeatureModules/Document/types/document.types';

export const DocumentCategoryLabels: Record<string, string> = {
  MANAGEMENT_LETTER: 'Management letter',
  CERTIFICATE: 'Certificate',
  SHAREHOLDER_AGREEMENT: 'Shareholder agreement',
  PICTURES: 'Pictures',
  LABORATORY_TEST: 'Laboratory test',
  REPORT: 'Report',
  STATEMENT: 'Statement',
  GEOGRAPHICAL_FEATURES: 'Geographical features',
  OTHER: 'Other document',
};

export const DocumentVisibilityLabels: Record<TDocumentVisibilityStatus, string> = {
  PRIVATE: 'Private',
  SELECTED: 'Partners', // Disabled for now until we develop the partner autocomplete
  PUBLIC: 'Public',
};
// to distinguish between other certificate and no certificate, we use the the OTHER_CERTIFICATE in the frontend.
export const OTHER_CERTIFICATE_ID = 'OTHER_CERTIFICATE';
